/// The backend's error responses are either a plain string (most controller
/// BadRequest(...) calls) or an object shaped like { title, traceId } /
/// { title, errors } (ExceptionHandlingMiddleware's JSON for unhandled
/// exceptions/validation failures) - never render the raw object directly as
/// a React child, or it crashes with "Objects are not valid as a React child".
export function getErrorMessage(err: unknown): string {
  const data = (err as { response?: { data?: unknown } })?.response?.data;
  if (typeof data === "string") return data;
  if (data && typeof data === "object" && "title" in data && typeof (data as { title: unknown }).title === "string") {
    return (data as { title: string }).title;
  }
  return "Something went wrong. Please try again.";
}
